export default "assets/images/icons/chevron-799dbab8.svg";